import { jsxs as a, jsx as l } from "react/jsx-runtime";
const r = (e) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ l("path", { fill: "currentcolor", d: "M15 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M21 7a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4zM7 5a2 2 0 0 0-2 2v5.586l2.293-2.293.014-.014C7.909 9.7 8.664 9.33 9.5 9.33s1.591.37 2.193.95l.014.013L14 12.586l.293-.293.014-.014c.602-.58 1.357-.949 2.193-.949s1.591.37 2.193.95l.014.013.293.293V7a2 2 0 0 0-2-2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
export {
  r as default
};
